import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RecalculateTasksCreateDialog from './RecalculateTasksCreateDialog';

class RecalculateTasksCreate extends Component {
  render() {
    return (
      <div>
        <RecalculateTasksCreateDialog
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
        />
      </div>
    );
  }
}

RecalculateTasksCreate.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

export default RecalculateTasksCreate;
